import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CHECKOUT_PAYMENT_COMPONENT } from '../../../brands/default/content/components/checkout';
import { formatCurrency } from '../../../helpers/currency';
import { isMobileViewport } from '../../../helpers/screen';
import ThemeContext from '../../../providers/ThemeProvider';

const PaymentSummary = ({
  currency,
  finalOrderAmount,
  isPostCheckout = false,
  totalQuantity,
  totalQuantityExceptGiftPack,
  vipPaywall,
}) => {
  const theme = useContext(ThemeContext);
  const formattedTotal = formatCurrency(
    currency,
    finalOrderAmount,
    true,
    false,
    false,
  );
  const isMobile = isMobileViewport();

  if (!isMobile && !isPostCheckout && !vipPaywall) {
    return null;
  }

  return (
    <>
      <p className="payment-summary">
        {CHECKOUT_PAYMENT_COMPONENT.paymentSummary.basketTotal} (
        <strong>
          {totalQuantityExceptGiftPack
            ? totalQuantityExceptGiftPack
            : totalQuantity}
        </strong>{' '}
        {CHECKOUT_PAYMENT_COMPONENT.paymentSummary.basketItems}):{' '}
        <strong>{formattedTotal}</strong>
      </p>
      <style jsx>{`
        .payment-summary {
          display: block;
          font-size: 1.5rem;
          text-align: center;
        }
        strong {
          color: ${theme.colors.primary};
          font-weight: normal;
        }
      `}</style>
    </>
  );
};

PaymentSummary.propTypes = {
  currency: PropTypes.string.isRequired,
  finalOrderAmount: PropTypes.number.isRequired,
  isPostCheckout: PropTypes.bool,
  totalQuantity: PropTypes.number.isRequired,
  totalQuantityExceptGiftPack: PropTypes.number,
  vipPaywall: PropTypes.bool,
};

export default PaymentSummary;
